'use client';

import tickerStyles from '@/components/section/scrolling-showcase/scrolling-ticker.module.scss';
import { assetIdFromUrl, useLogoAlt } from '@/components/studio/LogoAltContext';

type ContentfulAsset = {
  fields?: {
    file?: { url?: string };
  };
};

export type ScrollingShowcaseItemProps = {
  image?: string | ContentfulAsset | null;
  url?: string;
};

export const ScrollingShowcaseItem = ({ image, url }: ScrollingShowcaseItemProps) => {
  const logoAltMap = useLogoAlt();

  // A bound Media variable only ever gives us the asset URL — not its description. The image
  // URL contains the asset id, which we use to look up the description resolved server-side.
  let imageUrl = '';
  if (typeof image === 'string') {
    imageUrl = image.startsWith('//') ? `https:${image}` : image;
  } else if (image?.fields) {
    const rawUrl = image.fields.file?.url ?? '';
    imageUrl = rawUrl.startsWith('//') ? `https:${rawUrl}` : rawUrl;
  }

  if (!imageUrl) return null;

  const assetId = assetIdFromUrl(imageUrl);
  const alt = (assetId && logoAltMap[assetId]) || '';

  const imgContent = (
    <div className={tickerStyles.logo_img} draggable={false}>
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img src={imageUrl} alt={alt} />
    </div>
  );

  if (url) {
    return (
      <a href={url} target="_blank" rel="noopener noreferrer">
        {imgContent}
      </a>
    );
  }

  return <div>{imgContent}</div>;
};
